module.exports = __webpack_public_path__ + "static/media/app_design.15422843.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/app_design.jpg
// module id = 387
// module chunks = 0